import React, {Component} from 'react'
import {Input, InputGroup, InputGroupAddon, Button, Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap'
import {Query, Mutation} from 'react-apollo'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import 'react-table/react-table.css'
import {
    Redirect
} from "react-router-dom"
import {toast} from "react-toastify";

import projectInvoicingQuery from '../../../queries/reports/project_client_invoices'
import generateInvoicesMutation from '../../../queries/server/mutations/generate_invoices'
import setProjectClientInvoiceLocalMutation from '../../../queries/client_side/mutations/set_project_client_invoice'
import removeProjectClientInvoiceMutation from '../../../queries/server/mutations/remove_project_client_invoice'
import ProjectInvoicingTable from "./ProjectInvoicingTable";
import Loading from "../Loading";
import ProjectInvoiceBreakdownModal from "./ProjectInvoiceBreakdownModal";
import {checkPermission, REPORTS_INVOICING} from "../../../lib/permissions";
import classnames from 'classnames';
import ProjectInvoicesTable from "./ProjectInvoiceTable";
import ProjectInvoiceModal from "./ProjectInvoiceModal";
import ProjectInvoiceCreditNoteModal from "./ProjectInvoiceCreditNoteModal";
import ConfirmModal from "../ConfirmModal";

export default class ProjectInvoicing extends Component {

    state = {
        confirmDeleteModalOpen: false,
        deleteInvoiceID: null,
        isOpen: false,
        activeTab: 'new',
        invoiceOpen: false,
        invoiceID: null,
        creditNoteOpen: false,
        creditNoteInvoiceID: null,
        sorts: null,
        textFilters: null,
        dateFilters: null,
        limit: 20,
        offset: 0
    }

    toggle = () => {
        this.setState({isOpen: !this.state.isOpen})
    }

    toggleInvoice = () => {
        this.setState({invoiceOpen: !this.state.invoiceOpen})
    }

    toggleCreditNote = () => {
        this.setState({creditNoteOpen: !this.state.creditNoteOpen})
    }

    tabChanged = (activeTab) => {
        this.setState({activeTab})
    }

    toggleConfirmDeleteModal = (invoiceID) => {
      this.setState({confirmDeleteModalOpen: !this.state.confirmDeleteModalOpen, deleteInvoiceID: invoiceID})
    }

    fetchData = (state, instance) => {

      console.log(state)
      const {sorted, filtered} = state

      const dateFilters = filtered.filter(({id}) => ['paid_at', 'issued_at', 'created_at'].includes(id))
      const textFilters = filtered.filter(({id}) => !['paid_at', 'issued_at', 'created_at'].includes(id))

      const newSorts = (sorted && sorted.length) ? sorted.map(({id, desc}) => {
        return {
          key: id,
          value: (desc) ? 'desc' : 'asc'
        }
      }) : []

      const newFilters = (textFilters && textFilters.length) ? textFilters.map(({id, value}) => {
        return {
          key: id,
          value
        }
      }) : []

      const newDateFilters = (dateFilters && dateFilters.length) ? dateFilters.map(({id, value}) => {
        return {
          key: id,
          value: (value === 'SHOW_NULL') ? null : value
        }
      }) : []

      console.log(newDateFilters)

      this.setState({sorts: newSorts, textFilters: newFilters, dateFilters: newDateFilters, limit: state.pageSize, offset: state.pageSize * state.page})
    }

    render() {

        const {isOpen, sorts, textFilters, dateFilters, limit, offset} = this.state

        if(!checkPermission(REPORTS_INVOICING)) return <Redirect to="/projects"/>

        return (
            <Mutation mutation={setProjectClientInvoiceLocalMutation}>
                {(setProjectClientInvoiceLocalMutationFunc) => (
                    <Query query={projectInvoicingQuery} variables={{sorts, textFilters, dateFilters, limit, offset}}>
                        {({data, error, loading, refetch}) => {

                            console.log('data', data)

                            return (
                                <div className="d-flex flex-column">
                                  <ProjectInvoicesTable
                                      data={data.project_client_invoices || []}
                                      pages={Math.ceil(data.total_project_client_invoices / limit)}
                                      totalRecords={data.total_project_client_invoices}
                                      loading={loading}
                                      onFetchData={this.fetchData}
                                      onDelete={this.toggleConfirmDeleteModal}
                                      onSelect={(invoiceID) => {
                                          this.setState({invoiceID})
                                          this.toggleInvoice()
                                      }}
                                      onAddCreditNote={(creditNoteInvoiceID) => {

                                          console.log('creditNoteInvoiceID', creditNoteInvoiceID)

                                          this.setState({creditNoteInvoiceID})
                                          this.toggleCreditNote()
                                      }}
                                  />
                                  <ProjectInvoiceModal
                                      isOpen={this.state.invoiceOpen}
                                      toggle={this.toggleInvoice}
                                      onSave={() => {
                                          this.toggleInvoice()
                                          refetch()
                                      }}
                                      invoiceID={this.state.invoiceID}/>
                                  <ProjectInvoiceCreditNoteModal
                                      isOpen={this.state.creditNoteOpen}
                                      toggle={this.toggleCreditNote}
                                      onSave={() => {
                                          this.toggleCreditNote()
                                          refetch()
                                      }}
                                      invoice_id={this.state.creditNoteInvoiceID}
                                  />
                                  <Mutation mutation={removeProjectClientInvoiceMutation}>
                                    {(removeInvoiceFunc, {loading}) => (
                                      <ConfirmModal
                                        isOpen={this.state.confirmDeleteModalOpen}
                                        title="Confirm Delete Invoice"
                                        message="Are you sure you want to delete the selected invoice?"
                                        toggle={this.toggleConfirmDeleteModal}
                                        saving={loading}
                                        onConfirm={() => {
                                          removeInvoiceFunc({variables: {id: this.state.deleteInvoiceID}})
                                            .then(() => {
                                              refetch()
                                              toast.success('Invoice Deleted', {autoClose: 2000})
                                              this.setState({confirmDeleteModalOpen: false, deleteInvoiceID: null})
                                            })
                                            .catch(e => toast.error(e.message, {autoClose: false}))
                                        }}
                                      />
                                    )}
                                  </Mutation>
                                </div>

                            )
                        }}
                    </Query>
                )}

            </Mutation>
        )
    }

}